import { ListResponse, Params, Contact } from "../types";
import api from "./api";
import { API_ENDPOINTS } from "./endpoints";

const contactService = {
  async getContactList(params: Params): Promise<ListResponse<Contact>> {
    try {
      const response = await api.get(API_ENDPOINTS.CONTACTS.LIST, {
        params,
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },
};

export default contactService;